import {useState} from "react";

import '../popUps/styles.css'
import {
    Box,
    Typography,
    Grid,
    Stack,
    Card,
    Avatar,
    Divider,
    Button,
    Tooltip
} from '@mui/material';

import AllExercises from '../utente/AllExercises'
import FilterExs from '../popUps/FilterExs';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

function ViewAllExercises(){
    let nrSessoes = AllExercises.length;
    const [escolha, setEscolha] = useState(new Array(nrSessoes).fill(false));

    function handleClick(index){
        const update = escolha.map((obj,id) =>{
            if(id === index){
                if(escolha[index] === false){
                    return true;
                }else{
                    return false;
                }
                
            }
            return obj;
        })
        setEscolha(update);
    }
  return (
    <Box>
        <FilterExs />

        <Box marginTop={3}>
            <Grid container spacing={1} p={1} sx={{height: 350, overflow: "hidden", overflowY: "scroll"}} >
                
                {AllExercises.map((item, index) => (
                    <Grid key={index} item xs={4} md={4} lg={4} >
                        <Card >
                            <Box sx={{ p: 1, display:'flex'  }}> {/*  height: 160,*/}
                                <Avatar variant="rounded" src={item.url} />
                                <Stack marginLeft={1}>
                                    <Tooltip title={
                                        item.instrucoes.map((inst) => (
                                            <Typography key={inst.ordem} variant="body2">
                                            {inst.ordem}.º {inst.instrucao}
                                            </Typography>
                                        ))
                                    }>
                                        <Typography variant="subtitle1">{item.name}</Typography>
                                    </Tooltip>

                                    {item.category.map((category, index) => (
                                        <Typography key={index} sx={{color: '#595959'}} variant="body2">{category}</Typography>
                                    ))}
                                    
                                </Stack>
                            </Box>
                            
                            <Divider/>
                            <Grid container 
                                direction="column"
                                alignItems="center"
                                justifyContent="center">    
                            <Grid item xs={12} md={12} lg={12} paddingTop={1} paddingBottom={1}>
                                    { 
                                    escolha[index] === false && 
                                    <Button key={index} variant="outlined" endIcon={<AddIcon/>} aria-label="add" size="small" onClick = {() => handleClick(index)}>
                                        Adicionar
                                    </Button>
                                    }

                                    {escolha[index]  === true && 
                                    <Button key={index}  variant="contained" endIcon={<RemoveIcon fontSize="inherit" />} aria-label="remove" size="small" onClick = {() => handleClick(index)}>
                                        Remover
                                    </Button>
                                    }
                            </Grid>
                            </Grid>
                        </Card>
                        
                        {/*{itemVisibleCompleto === index && <VerExCompleto trigger={verExCompleto} AllExercises={item} setTrigger={setVerExCompleto}/>}*/}
                    </Grid>
                ))}
            </Grid>
        </Box>
    </Box>
  );
}
export default ViewAllExercises
